







































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PpiBundleTrenChart from "@/components/ppi/rekap/PpiBundleTrenChart.vue";
import { PpiTrenMode } from "@/services/PpiBundleRekapBulananService";
import {
  PpiKepatuhanAgregat,
  PpiKepatuhanKelompok,
  PpiKepatuhanModulMeta,
  PpiKepatuhanTren
} from "@/services/PpiRekapKepatuhanService";

const WARNA = [
  "#0072B2",
  "#E69F00",
  "#009E73",
  "#CC79A7",
  "#D55E00",
  "#56B4E9",
  "#000000"
];
const BENTUK_TITIK = ["circle", "triangle", "rect", "rectRot"];

@Component({
  components: { PpiBundleTrenChart }
})
export default class PpiKepatuhanTrenCard extends Vue {
  @Prop({ required: true }) readonly kelompok!: PpiKepatuhanKelompok;
  @Prop({ default: null }) readonly tren!: PpiKepatuhanTren | null;
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  @Prop({ default: "bulanan" }) readonly granularitas!: PpiTrenMode;

  seri = "semua";

  granularitasItems = [
    { text: "Bulan", value: "bulanan" },
    { text: "Triwulan", value: "triwulan" },
    { text: "Semester", value: "semester" },
    { text: "Tahun (5 tahun terakhir)", value: "tahunan" }
  ];

  @Watch("tren")
  onTrenChange() {
    if (
      this.seri !== "semua" &&
      !this.seriItems.some(i => i.value === this.seri)
    ) {
      this.seri = "semua";
    }
  }

  get judul(): string {
    return this.kelompok === "audit" ? "Audit PPI" : "Surveilans PPI";
  }

  get judulKolom(): string {
    return this.kelompok === "audit" ? "Jenis Audit" : "Surveilans";
  }

  get cakupanTeks(): string {
    if (!this.tren) return "";
    return this.tren.unit_id
      ? this.tren.unit_nama || this.tren.unit_id
      : `Cakupan ${this.tren.cakupan_label}`;
  }

  get seriItems(): Array<{ text: string; value: string }> {
    const semua = {
      text:
        this.kelompok === "audit" ? "Semua jenis audit" : "Hand Hygiene & APD",
      value: "semua"
    };
    if (!this.tren) return [semua];
    return [semua].concat(
      this.tren.modul.map(m => ({ text: m.label, value: m.key }))
    );
  }

  get modulTampil(): PpiKepatuhanModulMeta[] {
    if (!this.tren) return [];
    return this.seri === "semua"
      ? this.tren.modul
      : this.tren.modul.filter(m => m.key === this.seri);
  }

  get labels(): string[] {
    return this.tren ? this.tren.titik.map(t => t.singkat) : [];
  }

  get seriesTabel(): Array<
    PpiKepatuhanModulMeta & { titik: PpiKepatuhanAgregat[] }
  > {
    const tren = this.tren;
    if (!tren) return [];
    return this.modulTampil.map(m => ({
      ...m,
      titik: tren.titik.map(t => t.modul[m.key])
    }));
  }

  get seriesChart() {
    return this.seriesTabel.map((s, i) => ({
      label: s.singkat,
      data: s.titik.map(agg => (agg && agg.den > 0 ? agg.capaian : null)),
      color: WARNA[i % WARNA.length],
      pointStyle: BENTUK_TITIK[i % BENTUK_TITIK.length]
    }));
  }

  get targets(): Array<{ nilai: number; label: string }> {
    const perNilai: Record<string, string[]> = {};
    this.modulTampil.forEach(m => {
      const kunci = String(m.target);
      if (!perNilai[kunci]) perNilai[kunci] = [];
      perNilai[kunci].push(m.singkat);
    });
    const nilai = Object.keys(perNilai);
    return nilai.map(n => ({
      nilai: Number(n),
      label:
        nilai.length > 1
          ? `Target ${perNilai[n].join(", ")} ${this.fmtTarget(Number(n))}%`
          : `Target ${this.fmtTarget(Number(n))}%`
    }));
  }

  get adaData(): boolean {
    const tren = this.tren;
    if (!tren) return false;
    return tren.titik.some(t =>
      Object.keys(t.modul).some(k => t.modul[k].den > 0)
    );
  }

  fmt(val: number | null): string {
    if (val === null || val === undefined) return "—";
    return val.toFixed(2).replace(".", ",");
  }

  fmtTarget(val: number): string {
    return String(val).replace(".", ",");
  }

  kategoriClass(kategori: string): string {
    if (kategori === "baik") return "kat-baik";
    if (kategori === "cukup") return "kat-cukup";
    if (kategori === "kurang") return "kat-kurang";
    return "";
  }
}
